module.exports = __webpack_public_path__ + "static/media/users.3ed588cc.svg";